import { render, staticRenderFns } from "./UserFormBulkOps.vue?vue&type=template&id=bca8462e&"
import script from "./UserFormBulkOps.vue?vue&type=script&lang=js&"
export * from "./UserFormBulkOps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports